module.exports = "<p>Wing your way to Sydney and get great value for money with our special packages with Qantas and design hotel QT Sydney.</p> ";


//////////////////
// WEBPACK FOOTER
// ./src/Rist/content/markdown/news/travel-excerpt.md
// module id = 219
// module chunks = 0